import { useTranslation } from 'react-i18next';

import { useFeature } from '@treams/treams-hooks';
import { FeatureName } from '@treams/treams-network';
import {
	ArrowLeftIcon,
	Button,
	CityIcon,
	ConversationIcon,
	DialogueIcon,
	FriendsIcon,
	HistoryIcon,
	LibraryIcon,
	Sidebar,
	SuitcaseIcon,
} from '@treams/treams-ui';

import { useManagerMode } from '../ManagerModeContext';

export const HRBusinessPartnerItems = () => {
	const { t } = useTranslation();
	const managermode = useManagerMode();

	const hasCycles = useFeature(FeatureName.Cycles);

	return (
		<>
			{managermode.enabled ? (
				<Button
					title={t('sidebar.manager.back')}
					type="secondary"
					icon={<ArrowLeftIcon />}
					link="/manager"
					mb={4}
				/>
			) : (
				<Button
					title={t('sidebar.user.back')}
					type="secondary"
					icon={<ArrowLeftIcon />}
					link="/"
					mb={4}
				/>
			)}
			<Sidebar.Item
				small
				icon={<CityIcon />}
				title={t('settings.organization.title')}
				path="/settings/organization"
			/>
			<Sidebar.Item
				small
				icon={<FriendsIcon />}
				title={t('settings.employees.title')}
				path="/settings/employees"
			/>
			<Sidebar.Item
				small
				icon={<SuitcaseIcon />}
				title={t('settings.jobs.title')}
				path="/settings/jobs"
			/>
			{hasCycles && (
				<Sidebar.Item
					small
					icon={<HistoryIcon />}
					title={t('settings.cycles.title')}
					path="/settings/cycles"
				/>
			)}
			<Sidebar.SectionTitle mt={4} mb={1}>
				{t('settings.section.content')}
			</Sidebar.SectionTitle>
			<Sidebar.Item
				small
				icon={<DialogueIcon />}
				title={t('settings.feedback.title')}
				path="/settings/feedback"
			/>
			<Sidebar.Item
				small
				icon={<ConversationIcon />}
				title={t('settings.conversations.title')}
				path="/settings/conversations"
			/>
			<Sidebar.Item
				small
				icon={<LibraryIcon />}
				title={t('settings.learning.title')}
				path="/settings/learning"
			/>
		</>
	);
};
